import tw from "twin.macro";

export const NoSelect = tw.div`select-none`;
